/** Keep group labels/keys in sync with apps/bot/utils/logActions.js */

export const LOG_ACTION_GROUPS = {
  moderation: { label: "Moderation commands" },
  messages: { label: "Messages" },
  automod: { label: "Automod" },
  members: { label: "Members" },
  voice: { label: "Voice" },
  server: { label: "Server audit" },
  other: { label: "Other" },
};

export const LOG_ACTIONS = {
  ban: { label: "Ban", group: "moderation" },
  unban: { label: "Unban", group: "moderation" },
  kick: { label: "Kick", group: "moderation" },
  softban: { label: "Softban", group: "moderation" },
  timeout: { label: "Timeout", group: "moderation" },
  warn: { label: "Warn", group: "moderation" },
  jail: { label: "Jail", group: "moderation" },
  unjail: { label: "Unjail", group: "moderation" },
  purge: { label: "Purge", group: "moderation" },
  lock: { label: "Lock channel", group: "moderation" },
  unlock: { label: "Unlock channel", group: "moderation" },
  lockdown: { label: "Lockdown", group: "moderation" },
  slowmode: { label: "Slowmode", group: "moderation" },
  note: { label: "Mod note", group: "moderation" },
  reason: { label: "Case reason", group: "moderation" },
  clearhistory: { label: "Clear history", group: "moderation" },
  mod_role: { label: "Role command (/role)", group: "moderation" },
  mod_nickname: { label: "Nickname command", group: "moderation" },
  mod_move: { label: "Move member (voice)", group: "moderation" },
  mod_member_update: { label: "Member update (audit)", group: "moderation" },
  message_delete: { label: "Message deleted", group: "messages" },
  message_edit: { label: "Message edited", group: "messages" },
  automod: { label: "Automod filter", group: "automod" },
  member_roles: { label: "Role changes", group: "members" },
  member_nickname: { label: "Nickname changes", group: "members" },
  member_join: { label: "Member joined", group: "members" },
  member_leave: { label: "Member left", group: "members" },
  voice_join: { label: "Voice join", group: "voice" },
  voice_leave: { label: "Voice leave", group: "voice" },
  voice_move: { label: "Voice move", group: "voice" },
  user_report: { label: "User report", group: "other" },
  admin_settings: { label: "Admin / settings", group: "other" },
  server_guild: { label: "Server settings", group: "server" },
  server_channel: { label: "Channels", group: "server" },
  server_permissions: { label: "Channel permissions", group: "server" },
  server_role: { label: "Roles", group: "server" },
  server_invite: { label: "Invites", group: "server" },
  server_webhook: { label: "Webhooks", group: "server" },
  server_emoji: { label: "Emojis", group: "server" },
  server_sticker: { label: "Stickers", group: "server" },
  server_thread: { label: "Threads", group: "server" },
  server_soundboard: { label: "Soundboard", group: "server" },
};

export function actionsForGroup(groupKey) {
  return Object.entries(LOG_ACTIONS)
    .filter(([, meta]) => meta.group === groupKey)
    .map(([key, meta]) => ({ key, ...meta }));
}
